import { Injectable } from '@angular/core';
import {AbstractApiService} from "@shared/services/abstract-api.service";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class EdenredOneService extends AbstractApiService {

  constructor() {
    super();
  }

  public getEdenredOneHeader(): Observable<boolean> {
    return this._httpClient.get<boolean>( this.apiTMCustomer + '/Contract/GetActivateOneIntegration');
  }
}
